module.exports = __webpack_public_path__ + "img/demofoodshop.2ce84599.svg";